import { render, staticRenderFns } from "./StepInformer.vue?vue&type=template&id=1b754e5a&scoped=true&"
import script from "./StepInformer.vue?vue&type=script&lang=js&"
export * from "./StepInformer.vue?vue&type=script&lang=js&"
import style0 from "./StepInformer.vue?vue&type=style&index=0&id=1b754e5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b754e5a",
  null
  
)

export default component.exports